<template>
    <card>
      <template slot="header">
        <h3 class="card-title">Register Dependent</h3>
      </template>
      <nav class="row">
        <ol class="breadcrumb arr-right bg-breadcrum">
          <li class="breadcrumb-item">
            <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/hr/dependents">Dependents</router-link>
          </li>
          <li class="breadcrumb-item active">Dependent Registration</li>
        </ol>
      </nav>
      <hr style="margin-top:-10px"/>
      <form @submit.prevent="formSubmit">
        <label>Select Employee</label>
        <select  v-model="employee_id" class="form-control col-md-12" required>
          <option value="" >---- Select Employee ----</option>
          <option v-for="emp in employees" v-bind:value="emp.id">{{emp.full_name}}</option>
        </select>
        <br/>
        <font color="#4285f4" class="title-section"><i class="fa fa-male"></i>Dependents</font>
        <!-- DEPENDENTS  -->
        <div v-for="(dept ,index) in dependents">
          <div class="border-box-dependents">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>Name Of Dependent:</label>
                  <input type="text" v-model="dept.name" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Relationship:</label>
                  <select class="form-control" v-model="dept.relationship">
                    <option disabled value="">-- Please select one --</option>
                    <option value="Mother">Mother</option>
                    <option value="Father">Father</option>
                    <option value="Father">Daughter</option>
                    <option value="Son">Son</option>
                  </select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Age of Dependent:</label>
                  <the-mask :mask="['##']" class="form-control" v-model="dept.age"/>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Phic No. Of Dependent:</label>
                  <the-mask :mask="['##-#######-#']" placeholder="00-0000000-0" v-model="dept.phic_no" class="form-control"/>
                </div>
              </div>
            </div>
            <div class="floater-point-dept">
              <div class="action-item-dept">
                <div class="form-group">
                  <br/>
                  <button @click.stop.prevent="add_dependent" class="btn btn-xs btn-primary" v-b-tooltip.hover title="click to add new employee dependents section"><i class="fa fa-plus"></i></button>
                  <button @click.stop.prevent="deleteDependent(index)" class="btn btn-xs btn-primary" v-b-tooltip.hover title="click to remove employee dependents section"><i class="fa fa-minus"></i></button>
                </div>
              </div>
            </div>
          </div>
          <br/>
        </div>
        <!-- END DEPENDENTS --> 
        <font color="#4285f4" class="title-section"><i class="fa fa-blind"></i>Senior Citizen Dependent</font>  
        <!-- SENIOR CITIZEN DEPENDENTS  -->  
        <div v-for="senior,index in seniors">
          <div class="border-box-dependents">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label>Senior Citizen ID No. of Dependent:</label>
                  <the-mask :mask="['##-#######-#']" placeholder="00-0000000-0" v-model="senior.senior_citizen" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Middle Initial of Dependent:</label>
                  <input type="text" class="form-control" v-model="senior.middle_initial" pattern="[A-Za-z ]{1,32}" >
                </div>
              </div>
            </div>
            <div class="floater-point-sinior">
              <div class="action-item-sinior">
                <div class="form-group">
                  <br/>
                  <button @click.stop.prevent="add_senior(index)" class="btn btn-xs btn-primary" v-b-tooltip.hover title="click to add senior section"><i class="fa fa-plus"></i></button>
                  <button @click.stop.prevent="deleteSenior(index)" class="btn btn-xs btn-primary" v-b-tooltip.hover title="click to remove senior section"><i class="fa fa-minus"></i></button>
                </div>
              </div>
            </div>
          </div>
          <br/> 
        </div>
        <!--END HERE -->
        <br/>
        <div class="col-md-4 float-right">
          <div class="row">
            <div class="col-md-6">   
            </div>
            <div class="col-md-6">
              <button class="btn btn-info" style="width: 100%"><i class="fa fa-save"></i> Save Dependent Data</button> 
            </div>
          </div>
        </div>
      </form>
    </card>
  </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card,
  },

  data() {
    return {
      dependents: [{
        name: '',
        relationship: '',
        age: '',
        phic_no: '',

      }],
      seniors: [{
        senior_citizen: '',
        middle_initial: ''
      }],
      employees: [],
      employee_id: ''
    }
  },

  mounted: function () {
    this.get_employees()
  },

  methods: {
 
    add_dependent() {
      this.dependents.push({
        name: '',
        relationship: '',
        age: '',
        phic_no: ''
      })
    },
    add_senior(index) {
      this.seniors.push({
        senior_citizen: '',
        middle_initial: ''
      })

      if (index === 1)
        this.seniors.splice(index, 1);

    },
    deleteSenior(index) {
      console.log(index);
      console.log(this.finds);
      this.seniors.splice(index, 1);
      if (index === 0)
        this.add_senior()
    },
    deleteDependent(index) {
      console.log(index);
      console.log(this.finds);
      this.dependents.splice(index, 1);
      if (index === 0)
        this.add_dependent()
    },

    get_employees() {
      axios.get('api/employeenodependent')
        .then(response => {
          this.employees = response.data;
        })
        .catch(error => {
          console.log(error.response)
        });
    },


    formSubmit(e) {
      e.preventDefault();
      this.$swal({
          title: 'Are you sure?',
          text: 'Do you want to save',
          type: 'warning',
          showCancelButton: true,
          showCloseButton: false,
        })
        .then((isConfirm) => {
          if (isConfirm === true) {
            axios.post('api/registerdependent/add', {
                // DEPENDENTS
                employee_id: this.employee_id,
                dependents: JSON.stringify(this.dependents),
                seniors: JSON.stringify(this.seniors)
              })
              .then(resp => {
                this.$swal('Save', 'You successfully save this file', 'success')
                this.$router.push({
                  name: 'dependents'
                })
              })
              .catch(error => {
                console.log('response => ', error);
              });
          }
        });
    },
  },
}
</script>
<style>
.fa-update{
    color:#07b22c;
    font-size:19px;
}
.bg-breadcrum{
    background:#fff;
    }

    .m-right{
        margin:0px !important;
        padding-right: 0px!important;
    }
    .bg-breadcrum{
        background:#fff;
        }
        .border-box-dependents{
            border: 1px dashed #666;
            width: 100%;
            padding: 20px;
        }
        .font-awesome-size{
            font-size: 30px;
        }
        .action-item-exp{
            margin-top:-420px;
            position: absolute;
            /* background: yellow; */
            float:right;
        }
        .floater-point-exp{
            float: right;
            width: 100px;
            margin-right: -30px;
        }


        .action-item-dept{
            margin-top: -120px;
            position: absolute;
            /* background: yellow; */
            float:right;
        }
        .floater-point-dept{
            float: right;
            width: 100px;
            margin-right: -30px;
        }


        .action-item-senior{
        
            position: absolute;
            /* background: yellow; */
        }
        .floater-point-sinior{
            float: right;
            width: 100px;
            margin-right: -30px;
            margin-top: -120px;
        } 

        .title-section{
            font-size: 18px;
        }
</style>
    
    
    


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-dependents-form.vue